import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AssessmentService } from 'src/app/services/assessment.service';

@Component({
  selector: 'app-assessment-test',
  templateUrl: './assessment-test.component.html',
  styleUrls: ['./assessment-test.component.scss']
})
export class AssessmentTestComponent {
  @Input() assessment: any;
  @Input() mode: 'detail' | 'list' | 'admin' = 'detail';
  constructor(private route: ActivatedRoute, private assessmentService: AssessmentService) { }

  async ngOnInit() {
    if (!this.assessment && this.route.snapshot.params.id)
      this.assessment = await this.assessmentService.get(this.route.snapshot.params.id);
    this.assessment.TestId = this.assessment.Id;
    this.assessment.Answers = [];
  }

  async pay() {
    await this.assessmentService.pay(this.assessment.Id);
  }

  async saveResult() {
    await this.assessmentService.saveResult(this.assessment);
  }
}
